module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-grid justify-content-end"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0",
    attrs: {
      "icon": "pi pi-plus",
      "label": "NEW"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAddDialog.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialogs', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Company",
      "visible": _vm.addDisplayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.addDisplayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button",
          attrs: {
            "label": _vm.editing ? 'Update' : 'Add'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addCompany.apply(null, arguments)
            }
          }
        }), _vm._v(" "), (!_vm.editing) ? _c('Button', {
          staticClass: "p-button-raised p-button-primary",
          attrs: {
            "label": "Add & New"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addAndNewComany.apply(null, arguments)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addCancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "companyBusinessType"
    }
  }, [_vm._v("Business Type"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "companyBusinessType"
    },
    model: {
      value: (_vm.companyBusinessType),
      callback: function($$v) {
        _vm.companyBusinessType = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "companyBusinessType"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "companyDomain"
    }
  }, [_vm._v("Domain Name"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "companyDomain"
    },
    model: {
      value: (_vm.companyDomain),
      callback: function($$v) {
        _vm.companyDomain = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "companyDomain"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "contactNum"
    }
  }, [_vm._v("Contact Number")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "contactNum"
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.contactNumber),
      callback: function($$v) {
        _vm.contactNumber = $$v
      },
      expression: "contactNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "address"
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "numberOfEmployee"
    }
  }, [_vm._v("No of employee")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "numberOfEmployee"
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.numberOfEmployee),
      callback: function($$v) {
        _vm.numberOfEmployee = _vm._n($$v)
      },
      expression: "numberOfEmployee"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "annualRevenue"
    }
  }, [_vm._v("Annual Revenue")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "type": "text",
      "id": "annualRevenue"
    },
    model: {
      value: (_vm.annualRevenue),
      callback: function($$v) {
        _vm.annualRevenue = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "annualRevenue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "conDescription"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('Textarea', {
    staticClass: "form-control",
    attrs: {
      "id": "conDescription",
      "rows": "3"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5810141e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/crmDialog/crmCompaniesDialog.vue
// module id = 2241
// module chunks = 0